import classNames from 'classnames';
import React from 'react';
import ReviewComponent from '../Review';
import css from './ReviewList.module.scss';
import ReviewSummary from '../ReviewSummary';

import { MerchantReview } from '../../../../interfaces/merchants/reviews';
import { MerchantDetail } from '../../../../interfaces/merchants';

interface Props {
  className?: string;
  merchantDetail: MerchantDetail;
  reviews: MerchantReview[];
  max?: number;
  showHeader?: boolean;
  rate_count_starby?: {
    one: number;
    two: number;
    three: number;
    four: number;
    five: number;
  };
}

const ReviewList = ({
  className,
  merchantDetail,
  reviews,
  max,
  rate_count_starby,
}: Props) => {
  const classes = classNames(css.ReviewList, className);
  const rateCount = merchantDetail.rate_count;
  const rate = merchantDetail.rate;
  let recentReviews = reviews;
  if (max) {
    recentReviews = reviews.slice(0, max);
  }

  if (recentReviews.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      <div>
        {rate > 0 && rateCount > 0 && rate_count_starby && (
          <ReviewSummary
            className={css.ReviewList__Summary}
            rate={rate}
            rate_count={rateCount}
            rate_count_starby={rate_count_starby}
          />
        )}
      </div>
      {
        <ul className={css.ReviewList__Body}>
          {recentReviews.map((review, i) => (
            <ReviewComponent
              className={css.ReviewList__Review}
              review={review}
              key={i}
            />
          ))}
        </ul>
      }
    </div>
  );
};

export default ReviewList;
